// extracted by mini-css-extract-plugin
export var colorSquare = "_p2-0";
export var danger = "_p2-5";
export var lightPink = "_p2-8";
export var neutralBlue = "_p2-7";
export var neutralYellow = "_p2-6";
export var normal = "_p2-1";
export var primary = "_p2-2";
export var primaryLight = "_p2-3";
export var solidBlack = "_p2-g";
export var solidGreen = "_p2-b";
export var solidLightBlue = "_p2-d";
export var solidNavy = "_p2-c";
export var solidOrange = "_p2-f";
export var solidPink = "_p2-e";
export var solidRed = "_p2-9";
export var solidYellow = "_p2-a";
export var success = "_p2-4";